import { useEffect, useState } from 'react'

/** MyMine Version2.0 Mobile/Tablet表示対応
 * メディアサイズ判定用カスタムフック
 * @param {any} query
 * @returns
 */
export const useMediaQuery = (query) => {
  const formattedQuery = `(${query})`
  const [match, setMatch] = useState(matchMedia(formattedQuery).matches)

  useEffect(() => {
    const mql = matchMedia(formattedQuery)

    mql.onchange = (e) => {
      setMatch(e.matches)
    }

    return () => {
      mql.onchange = null
    }
  }, [formattedQuery, setMatch])

  return match
}

/** メディアクエリ */
export const mediaQuery = {
  mobile: 'width < 900px',
  pc: '900px <= width',
}